import React, { useContext } from 'react';
import { compact, isEmpty, find } from 'lodash';
import brain from 'images/brain.svg';
import { routes } from 'constants/config';
import { FilterContext } from 'components/shared/FilterContext/index';
import Count from '../_shared/Count';
import DataCard from '../_shared/DataCard';
import CriteriaRatingsTable from './CriteriaRatingsTable';
import DateRangeFormat from '../_shared/DateRangeFormat';

const FeedbackCriteriaInsights = () => {
  const { params: filters } = useContext(FilterContext);
  const hasDate = filters.start_date || filters.end_date;
  const hasGroups = !isEmpty(filters.group_ids);

  const withFilterQuery = url => compact([url, $.param(filters)]).join('?');

  const dateSubtitle = hasDate ? (
    <DateRangeFormat start={filters.start_date} end={filters.end_date} />
  ) : (
    t('insights.feedback_criteria.subtitle')
  );

  const countTooltip = find([
    hasDate &&
      hasGroups &&
      t('insights.feedback_criteria.tooltip_with_all_filters'),
    hasDate &&
      !hasGroups &&
      t('insights.feedback_criteria.tooltip_with_date_filter'),
    !hasDate &&
      hasGroups &&
      t('insights.feedback_criteria.tooltip_with_groups_filter'),
    t('insights.feedback_criteria.tooltip'),
  ]);

  return (
    <DataCard.Container className="d-f" direction="row">
      <DataCard.Header
        downloadLink={withFilterQuery(routes.INSIGHTS.PRACTICE.REPORT)}
        reportTitle={t('insights.feedback_criteria.report.title')}
        subtitle={dateSubtitle}
        title={t('insights.feedback_criteria.title')}
        tooltip={countTooltip}
      >
        <Count
          route={routes.INSIGHTS.PRACTICE.FEEDBACK_CRITERIA_RATINGS_COUNT}
          imgSrc={brain}
          imgDescription={t('insights.feedback_criteria.title')}
        />
      </DataCard.Header>
      <div className="d-f fd-c fg-1">
        <CriteriaRatingsTable
          url={routes.INSIGHTS.PRACTICE.HIGHEST_RATED_FEEDBACK_CRITERIA}
          title={t('insights.learner_impact.feedback_criteria.highest.title')}
          subtitle={dateSubtitle}
        />
        <CriteriaRatingsTable
          url={routes.INSIGHTS.PRACTICE.LOWEST_RATED_FEEDBACK_CRITERIA}
          title={t('insights.learner_impact.feedback_criteria.lowest.title')}
          subtitle={dateSubtitle}
        />
      </div>
    </DataCard.Container>
  );
};

export default FeedbackCriteriaInsights;
